export default __webpack_public_path__ + "bea3b0d.png";